import {
  PROPERTY_MANAGER_TYPE_INDIVIDUAL,
  PROPERTY_MANAGER_TYPE_BUSINESS,
} from 'common/partnerConstants';

const propertyManagerOptionItems = [
  {
    label: 'Individual',
    value: PROPERTY_MANAGER_TYPE_INDIVIDUAL,
  },
  {
    label: 'Business',
    value: PROPERTY_MANAGER_TYPE_BUSINESS,
  },
];

export default propertyManagerOptionItems;
